import React from 'react';
import { Spin } from 'antd';
import TruInfo from '../../blocks/PageInfo/TruInfo';

import style from './TruContent.module.scss';
import api from '../../../helpers/api';
import getReferrerFrom from '../../../helpers/lib/getReferrerFrom';

const TruContent = () => {
  const [loading, setLoading] = React.useState<boolean>(true);

  const [iframe, setIframe] = React.useState<any>();

  const onReport = async () => {
    await api.sendReport(api.API_TRU_REPORT_TYPE, {
      ...getReferrerFrom(),
    });
  };

  React.useEffect(() => {
    (async () => {
      const formData = new FormData();
      formData.append('workspaceId', '1561ffef-733d-4245-9304-967845c84e64');
      formData.append('reportId', 'a5342df8-56c9-4747-96ae-f55c6e6cd367');
      formData.append('role', '');
      formData.append('username', '');
      await fetch('https://biapi.tektorg.ru/Home/Report', {
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
        method: 'POST',
        body: formData,
      })
        .then((response) => response.text())
        .then((data) => {
          setLoading(false);
          setIframe(data);
        })
        .catch((e) => {
          console.log(e);
        });
    })();
  }, []);

  return (
    <>
      <div className={style.container}>
        <TruInfo />
      </div>
      <div className={style.frame}>
        {/* <iframe
          onLoad={onReport}
          width="100%"
          height="100%"
          title="Tru report"
          src="https://pix.tektorg.ru/shared/view/53aeaf19-ae3d-444f-8ba3-17724a730200"
        /> */}
        {!loading ? (
          <iframe onLoad={onReport} width="100%" height="100%" srcDoc={iframe} title="Visiology" />
        ) : (
          <div className={style.spin}>
            <Spin />
          </div>
        )}
      </div>
    </>
  );
};

export default TruContent;
